import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
  },
}));

const ChangeStatus = (props) => {
  const { handleClose, open, state, onHandleChange, onSaveClick } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={() => handleClose()}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`${state.selectedOrder.orderId} - ${state.selectedOrder.createdBy}`}</span>
          </Fragment>
        }
        content={
          <Fragment>
            <div>
              <div className={classes.label}>Order Id</div>
              <TextField
                placeholder="Order Id"
                variant="outlined"
                value={state.selectedOrder.orderId}
                fullWidth
                readOnly
                name="scannedOrderId"
                onChange={onHandleChange}
                InputProps={{ classes: { input: classes.resize } }}
              />
              {/* <div className={classes.label}>Delivery Partner</div> */}
              {/* <TextField
                placeholder="Delivery Partner"
                variant="outlined"
                fullWidth
                name="deliveryPartner"
                error={state.deliveryPartnerError}
                value={state.deliveryPartner}
                onChange={onHandleChange}
                InputProps={{ classes: { input: classes.resize } }}
                select
              >
                {state.deliveryPartnerData.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.label}
                    </MenuItem>
                  );
                })}
              </TextField> */}
            </div>
            <div className={classes.actions}>
              <Button
                onClick={() => onSaveClick()}
                disabled={state.isLoading}
                style={{ width: 100 }}
                variant="contained"
                color="primary"
              >
                {state.isLoading ? <CircularProgress size={30} /> : "Save"}
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                onClick={() => handleClose()}
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeStatus.propTypes = {
  handleClose: PropTypes.func,
  onHandleChange: PropTypes.func,
  onCheckClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeStatus.defaultProps = {
  handleClose: (fn) => fn,
  onHandleChange: (fn) => fn,
  onSaveClick: (fn) => fn,
  onCheckClick: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeStatus;
